import {
    CUSTOMER_AUTHENTICATE_BY_CODE_START,
    CUSTOMER_AUTHENTICATE_BY_CODE_SUCCESS,
    CUSTOMER_ERROR,
    CUSTOMER_REQUEST_AUTH_CODE_START,
    CUSTOMER_REQUEST_AUTH_CODE_SUCCESS,
    CUSTOMER_RESET,
    CustomerAction
} from 'actions/customer/CustomerActionsTypes';
import { CustomerState, CustomerStatus } from 'reducers/customer/CustomerState';
import { Reducer } from 'redux';

const initialState: CustomerState = {
    loading: false,
    status: CustomerStatus.Initial
};

export const customerReducer: Reducer<CustomerState, CustomerAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case CUSTOMER_RESET:
            return {
                ...initialState
            };
        case CUSTOMER_REQUEST_AUTH_CODE_START:
            return {
                ...state,
                loading: true,
                status: CustomerStatus.RequestAuthCodeStart
            };
        case CUSTOMER_REQUEST_AUTH_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: CustomerStatus.RequestAuthCodeSuccess
            };
        case CUSTOMER_AUTHENTICATE_BY_CODE_START:
            return {
                ...state,
                loading: true,
                status: CustomerStatus.AuthenticateByAuthCodeStart
            };
        case CUSTOMER_AUTHENTICATE_BY_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                customer: action.payload.customer,
                status: CustomerStatus.AuthenticateByAuthCodeSuccess
            };
        case CUSTOMER_ERROR:
            return {
                ...state,
                loading: false,
                status: CustomerStatus.Error
            };
        default:
            return state;
    }
};
